import { gql } from '@apollo/client'
import { graphql } from '@/graphql-setup'

export const VEHICLE_PLATE_NUMBERS_QUERY = gql`
  query VehiclePlateNumbers($q: String, $limit: Int) {
    vehiclePlateNumbers(q: $q, limit: $limit)
  }
`

export const ALL_VEHICLES_QUERY = gql`
  query AllVehicles($q: String, $orderBy: String, $currentlyOwned: Boolean) {
    allVehicles(q: $q, orderBy: $orderBy, currentlyOwned: $currentlyOwned) {
      edges {
        node {
          id
          vehicleType
          brand
          model
          vin
          registrationNumber
          vehicleType

          department {
            id
            name
            externalId
          }

          facility {
            id
            name
            externalId
          }

          vehicleFetchInfo {
            id
            lastFetch
            integrationEndpoint
          }

          vehicleNotes {
            id
            text
          }
        }
      }
    }
  }
`

export const ALL_VEHICLES_SELECT_QUERY = gql`
  query AllVehiclesSelect(
    $q: String
    $orderBy: String
    $currentlyOwned: Boolean
  ) {
    allVehicles(q: $q, orderBy: $orderBy, currentlyOwned: $currentlyOwned) {
      edges {
        node {
          id
          vin
          innerHeight
          innerWidth
          innerLength
          registrationNumber
          engineMaximumSpeed
          netWeight
        }
      }
    }
  }
`

export const VEHICLE_DETAIL_QUERY = graphql(`
  query VehicleDetail($id: ID!) {
    vehicle(id: $id) {
      id
      department {
        id
        name
      }
      facility {
        id
        name
      }
      phoneNumber
      email
      brand
      model
      vin
      registrationNumber
      registrationDate
      vehicleType
      vehicleTechnicalType
      color
      engineMaximumSpeed
      enginePower
      engineEuroClass
      engineVolume
      engineType
      netWeight
      payloadWeight
      allowedTotalWeight
      allowedTruckWeight
      allowedCouplingLoad
      allowedSemiTrailerWeight
      allowedFrontAxleLoad
      allowedBackAxleLoad
      # Service and Maintenance
      serviceAgreement
      tiresStuddedFront
      tiresStuddedBack
      tiresFrontDimension
      tiresDriveDimension
      tiresBogieDimension
      kmPerMonth
      kmPerYear
      # Administrative
      country
      stationingLocation
      soldDate
      licenseNumber
      tollTagNumber
      ferryCardNumber
      dieselCards {
        id
        number
        pinCode
      }
      previousPeriodicControl
      nextPeriodicControl
      # Use properties
      coolFreezeHeat
      height
      sideOpening
      hasCrane
      craneType
      backLifter
      vbgCoupling
      palletSpaces
      goodsInsuranceType
      extensionType
      innerHeight
      innerWidth
      innerLength
      loadingHeight
      fridge
      fridgeType
      meatRack
    }
  }
`)
export const VEHICLE_DOCUMENTS_QUERY = gql`
  query VehicleDocuments($vehicle: ID, $orderBy: String) {
    allVehicleDocuments(vehicle: $vehicle, orderBy: $orderBy) {
      edges {
        node {
          id
          name
          description
          file
          originalName
          expirationDate
          notificationTime
          vehicle {
            id
            registrationNumber
          }
          responsibleUser {
            id
            fullName
          }
        }
      }
    }
  }
`

export const VEHICLE_EXPIRATIONS_QUERY = gql`
  query VehicleExpirations(
    $vehicle: ID
    $expirationTypes: [ID!]
    $orderBy: String
  ) {
    allVehicleExpirations(
      vehicle: $vehicle
      expirationTypes: $expirationTypes
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          description
          expirationFrom
          expirationTo
          expirationDate
          notificationTime
          vehicle {
            id
            registrationNumber
          }
          responsibleUser {
            id
            fullName
          }
          expirationType {
            id
            name
          }
          expirationDuration
        }
      }
    }
  }
`

export const VEHICLE_NOTES_QUERY = gql`
  query VehicleNotes($vehicle: ID) {
    allVehicleNotes(vehicle: $vehicle) {
      edges {
        node {
          id
          text
          createdAt
          user {
            id
            fullName
          }
        }
      }
    }
  }
`

export const ALL_VEHICLE_EXPIRATION_TYPES_SHALLOW_QUERY = gql`
  query VehicleExpirationTypes($q: String, $orderBy: String) {
    allVehicleExpirationTypes(q: $q, orderBy: $orderBy) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`
